import Back from './Back.vue';

export default Back;



// WEBPACK FOOTER //
// ./src/pages/profile/components/back/index.ts